module.exports = __webpack_public_path__ + "img/27.5d4de325.png";